export const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_URL ?? '';
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL ?? '';
export const REST_URL = process.env.REACT_APP_REST_URL ?? '';
export const CDN_URL = process.env.REACT_APP_CDN_URL ?? '';
